import { render } from "./my-payslip.vue?vue&type=template&id=010bfab0&scoped=true"
import script from "./my-payslip.vue?vue&type=script&lang=js"
export * from "./my-payslip.vue?vue&type=script&lang=js"

import "./my-payslip.vue?vue&type=style&index=0&id=010bfab0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-010bfab0"]])

export default __exports__